import root from "react-shadow/styled-components";
import * as Sentry from "@sentry/react";

import styles from "./App.module.scss";
import Stepper, { Step } from "./Stepper";
import Reason from "./steps/Reason";
import CurrentScore from "./steps/CurrentScore";
import InlineResetCss from "./components/InlineResetCss";
import CurrentProblems from "./steps/CurrentProblems";
import PersonalInfo from "./steps/PersonalInfo";
import Recommendations from "./steps/Recommendations";
import Plans from "./steps/Plans";
import Payment from "steps/Payment";
import GettingStarted from "steps/GettingStarted";
import GlobalStyles from "GlobalStyles";
import ConfirmProvider from "components/Confirm";
import FullScreenSpinnerProvider from "components/FullScreenSpinner";
import { colors } from "styles";

const App = () => {
  return (
    <root.div className={styles.root}>
      <FullScreenSpinnerProvider>
        <ConfirmProvider>
          <Stepper
            debug={
              process.env.REACT_APP_DEBUGGER === "true" ||
              process.env.NODE_ENV === "development"
            }
            $progressBar
            $progressBarFrom={0}
            startFrom={3}
            initialData={
              process.env.NODE_ENV === "development"
                ? {
                    reason: "home",
                    currentScore: 450,
                    currentProblems: ["inquiries"],
                    // personalInfo: {
                    //   firstName: "Giuliano Kranevitter",
                    //   email: "giuliano2911+prueba@gmail.com",
                    //   // phoneNumber: "9171112222",
                    // },
                    // recommendations: {
                    //   selectedOptions: [
                    //     "collection",
                    //     "late-payments",
                    //     "secured-credit-card",
                    //   ],
                    // },
                    // gettingStarted: {},
                  }
                : {
                    reason: "home",
                    recommendations: {
                      selectedOptions: ["collection", "late-payments"],
                    },
                  }
            }
          >
            {/* 0 */}
            <Step id="reason" timeToComplete={30}>
              <Reason />
            </Step>

            {/* 1 */}
            <Step id="currentScore" timeToComplete={30}>
              <CurrentScore />
            </Step>

            {/* 2 */}
            <Step id="currentProblems" timeToComplete={30}>
              <CurrentProblems />
            </Step>

            {/* 3 */}
            <Step id="personalInfo" timeToComplete={30}>
              <PersonalInfo />
            </Step>

            {/* 4 */}
            <Step id="recommendations" timeToComplete={6}>
              <Recommendations />
            </Step>

            {/* 5 */}
            <Step id="gettingStarted" timeToComplete={0} omitBack>
              <GettingStarted />
            </Step>

            {/* 6 */}
            <Step id="plan" timeToComplete={3}>
              <Plans />
            </Step>

            {/* 7 */}
            <Step id="payment" timeToComplete={3}>
              <Payment />
            </Step>
          </Stepper>

          <InlineResetCss />

          <GlobalStyles />
        </ConfirmProvider>
      </FullScreenSpinnerProvider>
    </root.div>
  );
};

export default Sentry.withErrorBoundary(App, {
  fallback: (
    <div
      style={{
        padding: 20,
        color: colors.red,
      }}
    >
      La application ha tenido un error. Por favor comuniquese con soporte
      tecnico.
    </div>
  ),
  beforeCapture: (scope) => {
    scope.setExtra("component", "App");
  },
});
